import type { FacetOption } from '../types/Facet';

export const setOptionActiveByValue = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
  active: boolean,
): FacetOption[] => {
  return facetOptions.map((option) => {
    if (option.value === value) {
      return {
        ...option,
        active,
      };
    }

    return option;
  });
};

export const setOptionToActiveRemoveOthers = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
): FacetOption[] => {
  const activatedOption = facetOptions.find((option) => option.value === value)!;

  return [{ ...activatedOption, active: true }];
};

export const setOptionToActiveSetOthersToInactive = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
) => {
  return facetOptions.map((option) => {
    return {
      ...option,
      active: option.value === value,
    };
  });
};
